var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"filterable":"","disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.zoneId),callback:function ($$v) {_vm.zoneId=$$v},expression:"zoneId"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }